export * from './src/events-notifications-v2-notification-config-notifications.schemas.js';
